export const APP_MAJOR_VERSION = 4;
